import { journeyAction, } from './base';

import { JourneyActionVoiceExternalDial as JourneyActionVoiceExternalDialBase, } from 'atlas-shared';

export const JourneyActionVoiceExternalDial = journeyAction({
  ...JourneyActionVoiceExternalDialBase,
  icon: 'Dial',
});
